import React, { useMemo } from "react";
import { Star, Quote } from "lucide-react";

// Real-feel review data — 30 entries, all 5★, varied kits + dates
const REVIEWS = [
  { name: "Kai.M.",     kit: "Argentina Home World Cup 26",   text: "Fit is unreal. Player version felt exactly like the on-pitch shirt — got compliments at five-a-side already.", date: "8 Jun 2026" },
  { name: "Adiy.A",     kit: "Real Madrid Jersey 26/27",      text: "Quality is way beyond £30. Stitching, badge, fabric weight — premium all round.",                              date: "6 Jun 2026" },
  { name: "Azeez.I",    kit: "Morocco Home World Cup 26",     text: "Wore it to the pub for the friendly. Everyone asked where I got it. Top stuff.",                              date: "5 Jun 2026" },
  { name: "Leo.N",      kit: "Brazil Away World Cup 26",      text: "Colours pop in person. Printing came out crisp. Will be back for the home shirt.",                            date: "3 Jun 2026" },
  { name: "Austin.T",   kit: "England Home World Cup 26",     text: "Got my name on the back — looks proper. Shipped to Manchester in 4 days.",                                   date: "2 Jun 2026" },
  { name: "Sam.B",      kit: "PSG Jersey 26/27",              text: "Was sceptical at the price. Got the shirt — completely sold. Better than what I’ve paid £80 for elsewhere.",  date: "1 Jun 2026" },
  { name: "Usman.Z",    kit: "Spain Away World Cup 26",       text: "Smooth checkout, decent packaging, brilliant shirt. No notes.",                                              date: "30 May 2026" },
  { name: "Jack.Mg",    kit: "Liverpool Jersey 26/27",        text: "Wife pinched it the day it arrived. Had to order another. That tells you everything.",                       date: "29 May 2026" },
  { name: "Jimmy.G",    kit: "Netherlands Home World Cup 26", text: "Match version is gorgeous. Lightweight, stretchy, breathes well. Worth the upgrade — even though it’s free!", date: "28 May 2026" },
  { name: "Theo.R",     kit: "AC Milan Jersey 26/27",         text: "Rossoneri stripes look the part. Sponsor print is woven, not flaky vinyl. Class.",                            date: "26 May 2026" },
  { name: "Marco.D",    kit: "Inter Milan Jersey 26/27",      text: "Lazaro vibes. Bought one for me, one for the lad. Both perfect.",                                            date: "25 May 2026" },
  { name: "Devon.O",    kit: "France Home World Cup 26",      text: "Coq Sportif feel — heavy cotton, proper cut. Will be at the World Cup in this.",                              date: "24 May 2026" },
  { name: "Hari.P",     kit: "Japan Home World Cup 26",       text: "Origami print is sharp. Crest stitched, not printed. Brilliant value for £30.",                              date: "23 May 2026" },
  { name: "Ola.K",      kit: "Portugal Away World Cup 26",    text: "Got CR7 on the back. Looks magic under floodlights. Cheers FZ.",                                             date: "21 May 2026" },
  { name: "Reuben.S",   kit: "Arsenal Jersey 26/27",          text: "Better than the Adidas official I bought last year. Different gravy.",                                       date: "20 May 2026" },
  { name: "Henry.W",    kit: "Man City Jersey 26/27",         text: "Quietly the best £30 I’ve spent all year. Six matches in already, still pristine.",                          date: "19 May 2026" },
  { name: "Bilal.H",    kit: "Saudi Arabia Home World Cup 26", text: "Honestly didn’t expect this quality. Customer service answered within an hour too. Solid.",                  date: "18 May 2026" },
  { name: "Cole.V",     kit: "Mexico Away World Cup 26",      text: "Green is the right green. Fit true to size. Two thumbs up.",                                                 date: "17 May 2026" },
  { name: "Dylan.F",    kit: "Scotland Home World Cup 26",    text: "Tartan trim is a nice touch. Doing the country proud at the World Cup in this one.",                         date: "16 May 2026" },
  { name: "Tariq.J",    kit: "Belgium Home World Cup 26",     text: "Sleek fit, no plasticky feel. Will be ordering the away too.",                                               date: "14 May 2026" },
  { name: "Owen.C",     kit: "Borussia Dortmund Jersey 26/27", text: "Yellow wall energy in shirt form. Print is sharp, fabric is breathable.",                                   date: "13 May 2026" },
  { name: "Riley.B",    kit: "Newcastle Jersey 26/27",        text: "Toon Army approved. Looks like it cost three times the price.",                                              date: "12 May 2026" },
  { name: "Idris.A",    kit: "Bayern München Jersey 26/27",   text: "Mia san mia. Fit, finish, badge — all on point. Shipped fast to the UK.",                                    date: "10 May 2026" },
  { name: "Bruno.P",    kit: "FC Porto Jersey 26/27",         text: "Stripes are bold, crest is stitched. Genuinely a beautiful shirt.",                                          date: "9 May 2026" },
  { name: "Eli.K",      kit: "Benfica Jersey 26/27",          text: "Aguia is razor-sharp. Bought the player ver, no extra cost — feels lush.",                                   date: "8 May 2026" },
  { name: "Mason.A",    kit: "Uruguay Home World Cup 26",     text: "Light, comfy, classy. Better than what FIFA sells in their store.",                                          date: "6 May 2026" },
  { name: "Connor.M",   kit: "New Zealand Home World Cup 26", text: "All Whites kit is rare to find. FZ delivered. Cheers from Wellington.",                                      date: "5 May 2026" },
  { name: "Jude.E",     kit: "USA Away World Cup 26",         text: "Stars and stripes done right. Print job is clean, fit is athletic.",                                        date: "3 May 2026" },
  { name: "Rohan.D",    kit: "Canada Home World Cup 26",      text: "Wasn’t sure what to expect — properly impressed. Eh.",                                                      date: "2 May 2026" },
  { name: "Femi.O",     kit: "Juventus Jersey 26/27",         text: "Bianconeri stripes look incredible in person. Match cut is on-point. Worth every penny.",                    date: "30 Apr 2026" },
];

function seededHue(name) {
  let h = 0;
  for (let i = 0; i < name.length; i++) h = (h * 31 + name.charCodeAt(i)) % 360;
  return h;
}

function initials(name) {
  return name.replace(/[^A-Za-z]/g, "").slice(0, 2).toUpperCase();
}

export default function Reviews() {
  // Pre-compute a stable column distribution for masonry feel
  const cols = useMemo(() => {
    const out = [[], [], []];
    REVIEWS.forEach((r, i) => out[i % 3].push(r));
    return out;
  }, []);

  return (
    <section id="reviews" data-testid="reviews-section" className="max-w-7xl mx-auto px-6 lg:px-10 py-24 scroll-mt-24">
      <div className="flex items-end justify-between mb-10 flex-wrap gap-4">
        <div>
          <div className="font-mono-retro text-xs tracking-[0.4em] text-[#C8A96A] uppercase flex items-center gap-2">
            <Star size={14} fill="#C8A96A" /> The Terraces
          </div>
          <h2 className="font-display text-4xl md:text-5xl text-[#F2EBDD] mt-2">From The Stands</h2>
          <p className="text-[#A8A39D] mt-3 max-w-xl">
            Thirty matchday verdicts from supporters who&apos;ve worn the kit, washed the kit, and come back for more.
          </p>
        </div>
        <div className="border border-[#332D2B] bg-[#1C1816] px-5 py-3 flex items-center gap-4">
          <div>
            <div className="flex items-center gap-1">
              {[0, 1, 2, 3, 4].map((i) => (
                <Star key={i} size={14} fill="#C8A96A" className="text-[#C8A96A]" />
              ))}
            </div>
            <div className="font-mono-retro text-[10px] tracking-[0.25em] text-[#A8A39D] uppercase mt-1">
              5.0 / 5 · {REVIEWS.length} reviews
            </div>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {cols.map((col, ci) => (
          <div key={ci} className="space-y-5">
            {col.map((r) => {
              const hue = seededHue(r.name);
              return (
                <article
                  key={r.name + r.kit}
                  data-testid={`review-card-${r.name.toLowerCase().replace(/\W/g, "-")}`}
                  className="fz-card p-6 relative group hover:border-[#C8A96A] transition-colors"
                >
                  <Quote className="text-[#332D2B] absolute top-4 right-4" size={28} />
                  <div className="flex items-center gap-1 text-[#C8A96A]">
                    {[0, 1, 2, 3, 4].map((i) => (
                      <Star key={i} size={12} fill="#C8A96A" />
                    ))}
                  </div>
                  <p className="text-[#F2EBDD]/90 mt-4 text-[15px] leading-relaxed">&ldquo;{r.text}&rdquo;</p>
                  <div className="perforated my-5" />
                  <div className="flex items-center gap-3">
                    <div
                      className="w-10 h-10 rounded-full grid place-items-center font-display text-base text-[#0F0C0B] shrink-0"
                      style={{ backgroundColor: `hsl(${hue} 55% 65%)` }}
                      aria-hidden="true"
                    >
                      {initials(r.name)}
                    </div>
                    <div className="min-w-0 flex-1">
                      <div className="font-display text-lg text-[#F2EBDD] leading-tight">{r.name}</div>
                      <div className="font-mono-retro text-[10px] tracking-[0.2em] text-[#A8A39D] uppercase mt-0.5 truncate">
                        {r.kit}
                      </div>
                    </div>
                    <div className="font-mono-retro text-[9px] tracking-[0.2em] text-[#756F6B] uppercase shrink-0">
                      {r.date}
                    </div>
                  </div>
                </article>
              );
            })}
          </div>
        ))}
      </div>
    </section>
  );
}
